import React, { useState, useContext, useEffect } from "react";
import { Formik } from "formik";
import { Table, Empty, Button, Space, Popconfirm, Select } from "antd";

import { Link } from "react-router-dom";
//import dayjs from "dayjs";
import $ from "jquery";

import * as Yup from "yup";
import ErrorMessage from "../components/ErrorMessage";

import authClient from "../api/authClient";
import AuthContext from "../auth/context";

import format from "dayjs";

import "antd/dist/antd.css";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const { Option } = Select;

const columns = [
  {
    title: "Nom",
    dataIndex: "nom",
    key: "nom",
    sorter: (a, b) => a.nom.localeCompare(b.nom),
  },
  {
    title: "Prénom",
    dataIndex: "prenom",
    key: "prenom",
    sorter: (a, b) => a.prenom.localeCompare(b.prenom),
  },
  {
    title: "IMEI",
    dataIndex: "imei",
    key: "imei",
    sorter: (a, b) => {
      let strA = a.imei ? a.imei : "";
      let strB = b.imei ? b.imei : "";
      return strA.localeCompare(strB);
    },
  },
  {
    title: "Identifiant d'origine",
    dataIndex: "idOrigine",
    key: "idOrigine",
  },
  {
    title: "Téléphone",
    dataIndex: "telephone",
    key: "telephone",
  },
  {
    title: "Mobile",
    dataIndex: "mobile",
    key: "mobile",
  },
  {
    title: "Mobile Pro.",
    dataIndex: "mobileProfessionnel",
    key: "mobileProfessionnel",
  },
];

const validationSchema = Yup.object().shape({
  societe: Yup.string().required("La société est obligatoire"),
});

const Salaries = () => {
  const [loading, setLoading] = useState(false);
  const [initDone, setInitDone] = useState(false);
  const [listeSocietes, setListeSocietes] = useState([]);
  const [listeSalaries, setListeSalaries] = useState([]);

  const authContext = useContext(AuthContext);

  useEffect(() => {
    initListes();
  }, []);

  const initListes = async () => {
    setLoading(true);

    const retour = await authClient.getSocietes();

    setLoading(false);

    console.log(retour);

    if (!retour.ok) {
      if (retour.status === 401 || retour.status === 403) {
        localStorage.removeItem("currentUser");
        authContext.setUser(null);
      } else {
        console.log("toast");
        toast.error("Une erreur inattendue est survenue");
      }
    } else {
      if (retour.data) {
        setListeSocietes(retour.data);
      } else {
        setListeSocietes(undefined);
      }

      setInitDone(true);
    }
  };

  const lancerRecherche = async (values) => {
    setLoading(true);
    const retour = await authClient.getSalaries(values);

    setLoading(false);

    if (!retour.ok) {
      if (retour.status === 401 || retour.status === 403) {
        localStorage.removeItem("currentUser");
        authContext.setUser(null);
      } else {
        toast.error("Une erreur inattendue est survenue");
      }
    } else {
      if (retour.data) {
        setListeSalaries(retour.data);
      } else {
        setListeSalaries(undefined);
      }
    }
  };

  const zoneDetailSalarie = (record) => (
    <>
      <div className="row mb-2">
        <div className="col">
          <div className="row">
            <div className="col">
              <b>
                {record.nom} {record.prenom}
              </b>
            </div>
          </div>
          <div className="row">
            <div className="col">Matricule : {record.matricule}</div>
          </div>
          <div className="row">
            <div className="col">Poste : {record.poste}</div>
          </div>
          <div className="row">
            <div className="col">
              <i className="uil-map-marker mr-1"></i>
              {record.numeroEtVoie}
            </div>
          </div>
          {record.adresseSuite && (
            <div className="row">
              <div className="col">{record.adresseSuite}</div>
            </div>
          )}

          <div className="row">
            <div className="col">
              {record.codePostal} {record.ville}
            </div>
          </div>
          <div className="row">
            <div className="col">
              <i className="uil-envelope mr-1"></i>
              <a href={"mailto:" + record.email}>{record.email}</a>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <i className="uil-phone mr-1"></i>
              Téléphone : {record.telephone}
            </div>
          </div>
          <div className="row">
            <div className="col">
              <i className="uil-phone mr-1"></i>
              Mobile : {record.mobile}
            </div>
          </div>
          <div className="row">
            <div className="col">
              <i className="uil-phone mr-1"></i>
              Pro : {record.mobileProfessionnel}
            </div>
          </div>
        </div>
        <div className="col">
          <div className="row">
            <div className="col">
              Version installée : <b>{record.version}</b>
            </div>
          </div>
          <div className="row">
            <div className="col">
              OS : <b>{record.osVersion} </b>
            </div>
          </div>

          <div className="row">
            <div className="col">
              Marque : <b>{record.marque} </b>
            </div>
          </div>
          <div className="row">
            <div className="col">
              Modèle : <b>{record.modele} </b>
            </div>
          </div>
          <div className="row">
            <div className="col">
              Possède NFC :{" "}
              {record.possedeNfc ? (
                <span className={"badge badge-success-lighten p-1"}>OUI</span>
              ) : (
                <span className={"badge badge-danger-lighten p-1"}>NON</span>
              )}
            </div>
          </div>
          <div className="row">
            <div className="col">
              NFC Actif :{" "}
              {record.nfcActif ? (
                <span className={"badge badge-success-lighten p-1"}>OUI</span>
              ) : (
                <span className={"badge badge-danger-lighten p-1"}>NON</span>
              )}
            </div>
          </div>
          {record.niveauBatterie && (
            <>
              <div className="row">
                <div className="col">
                  Niveau de batterie : <b>{record.niveauBatterie} </b> % à{" "}
                  <b>
                    {record.localDateHeureNiveauBatterie &&
                      format(record.localDateHeureNiveauBatterie).format(
                        "HH:mm, le DD/MM/YYYY"
                      )}
                  </b>
                </div>
              </div>
            </>
          )}
        </div>
        <div className="col">
          <div className="row">
            <div className="col">
              Dernière ré-initialisation : à{" "}
              <b>
                {" "}
                {record.localLastInit &&
                  format(record.localLastInit).format("HH:mm, le DD/MM/YYYY")}
              </b>
            </div>
          </div>
          <div className="row">
            <div className="col">
              Dernière synchro périodique : à{" "}
              <b>
                {" "}
                {record.localLastSynchro &&
                  format(record.localLastSynchro).format(
                    "HH:mm, le DD/MM/YYYY"
                  )}
              </b>
            </div>
          </div>
          <div className="row">
            <div className="col">
              Dernier envoi de pointages : à{" "}
              <b>
                {" "}
                {record.localLastPushPointages &&
                  format(record.localLastPushPointages).format(
                    "HH:mm, le DD/MM/YYYY"
                  )}
              </b>
            </div>
          </div>
          <div className="row">
            <div className="col">
              Dernière demande d'infos du téléphone : à{" "}
              <b>
                {record.localLastGetSynchro &&
                  format(record.localLastGetSynchro).format(
                    "HH:mm, le DD/MM/YYYY"
                  )}
              </b>
            </div>
          </div>
        </div>
      </div>
    </>
  );

  if (!initDone)
    return (
      <>
        <ToastContainer />
      </>
    );

  return (
    <>
      <ToastContainer />
      <div
        className="modal fade"
        id="userModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Détails du salarié
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div className="modal-body">
              <div className="form-group mb-1">
                <label htmlFor="loginUser">Identifiant</label>
              </div>
              <div className="form-group mb-1">
                <label htmlFor="nomUser">Nom</label>
              </div>
              <div className="form-group mb-1">
                <label htmlFor="prenomUser">Prénom</label>
              </div>
              <div className="form-group mb-1">
                <label htmlFor="emailUser">Email</label>
              </div>
            </div>
            <div className="modal-footer">
              <Button
                loading={loading}
                className="btn btn-secondary"
                type="primary"
                data-dismiss="modal"
              >
                Fermer
              </Button>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <div className="page-title-box">
            <h4 className="page-title">Salariés</h4>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col">
          <div className="card mb-4">
            <div className="card-header">Critères de recherche</div>
            <div className="card-body">
              <Formik
                validationSchema={validationSchema}
                initialValues={{
                  societe: "",
                  nom: "",
                  prenom: "",
                  imei: "",
                }}
                onSubmit={(values) => {
                  lancerRecherche(values);
                }}
              >
                {({
                  handleChange,
                  handleSubmit,
                  errors,
                  setFieldTouched,
                  touched,
                  setFieldValue,
                  setErrors,
                  values,
                }) => (
                  <>
                    <div className="form-row">
                      <div className="col-md-4">
                        <div className="form-group">
                          <label htmlFor="societe">Société :</label>
                          <Select
                            showSearch
                            filterOption={(input, option) =>
                              option.children
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                            }
                            id="societe"
                            value={values["societe"]}
                            onChange={handleChange("societe")}
                            className="form-control"
                          >
                            <Option value="">
                              Veuillez sélectionner une société
                            </Option>
                            {listeSocietes.map((s) => (
                              <Option
                                key={s.idSociete}
                                value={s.idSociete.toString()}
                              >
                                {s.nomSociete}
                              </Option>
                            ))}
                          </Select>
                          <ErrorMessage
                            error={errors.societe}
                            visible={touched.societe}
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label htmlFor="nom">Nom :</label>
                          <input
                            value={values["nom"]}
                            onChange={handleChange("nom")}
                            className="form-control"
                            id="nom"
                            type="text"
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label htmlFor="prenom">Prénom :</label>
                          <input
                            value={values["prenom"]}
                            onChange={handleChange("prenom")}
                            className="form-control "
                            id="prenom"
                            type="text"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="col-md-4">
                        <div className="form-group">
                          <label htmlFor="imei">IMEI :</label>
                          <input
                            value={values["imei"]}
                            onChange={handleChange("imei")}
                            className="form-control "
                            id="imei"
                            type="text"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="form-group d-flex align-items-center justify-content-end mt-2 mb-0 ">
                      <Button
                        loading={loading}
                        className="btn btn-primary"
                        type="primary"
                        onClick={handleSubmit}
                      >
                        Rechercher
                      </Button>
                    </div>
                  </>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col">
          <div className="card mb-4">
            <div className="card-header">Liste des Salariés</div>
            <div className="card-body">
              <div className="table-responsive">
                <Table
                  rowKey="id"
                  loading={loading}
                  columns={columns}
                  dataSource={listeSalaries}
                  expandable={{
                    expandedRowRender: (record) => zoneDetailSalarie(record),
                  }}
                  locale={{
                    sortTitle: "trier",
                    cancelSort: "Cliquez pour annuler le tri",
                    triggerAsc: "Cliquez pour un tri ascendant",
                    triggerDesc: "Cliquez pour un tri descendant",
                    emptyText: (
                      <Empty
                        image="https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg"
                        imageStyle={{
                          height: 60,
                        }}
                        description={<span>Aucun Salarié</span>}
                      ></Empty>
                    ),
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Salaries;
